import React from 'react'
import img1 from '../Ecomphotos/bass.jpg'
import img2 from '../Ecomphotos/adventure1.jpg'
import img3 from '../Ecomphotos/summer.jpg'
import img4 from '../Ecomphotos/Couple.jpg'
export default function Summer() {
  return (
    <div>
        <div className="container mb-5">
            <div className="row">
                <h2 className='text-center p-5'>Explore the Best of Our Summer Tours Packages</h2>
                <div className="col-md-3">
                    <div className="card1">

                    <img src={img1} className='img-fluid pack' alt="" />
                    <span>Student Tour</span>
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="card1">

                    <img src={img2} className='img-fluid pack' alt="" />
                    <span>Adventure Tour</span>
                    </div>
                </div>
                <div className="col-md-3">
                    <div className='card1'>

                    <img src={img3} className='img-fluid pack' alt="" />
                    <span className='text-center 'col-md-12>Summer Tour</span>
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="card1">

                    <img src={img4} className='img-fluid pack' alt="" />
                    <span className='text-center'>Couple Tour</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}
